<!--
보류보관(설정) 컴포넌트
------------------------------------
-->
<template>
    <div class="uk-flex-top" uk-modal esc-close="false" bg-close="false">
        <div class="uk-modal-dialog uk-margin-auto-vertical uk-width-auto">

            <!-- stepper -->
            <div class="uk-modal-header">
                <div class="stepper">
                    <div
                        class="step"
                        :class="step1Class"
                    >
                        <div class="circle">1</div>
                        <div class="label">보류설정</div>
                    </div>
                    <div class="divider"></div>
                    <div
                        class="step"
                        :class="step2Class"
                    >
                        <div class="circle">2</div>
                        <div class="label">보관장소</div>
                    </div>
                    <div class="divider"></div>
                    <div
                        class="step"
                        :class="step3Class"
                    >
                        <div class="circle">3</div>
                        <div class="label">라벨출력</div>
                    </div>
                </div>
            </div>


            <div class="uk-modal-body uk-padding-small">
                <!-- 보류설정 -->
                <div v-show="currStep === 1">


                    <div class="uk-text-large uk-text-right uk-margin-bottom">
                        <i class="material-icons uk-text-middle" style="font-size: 34px">
                            info
                        </i>
                        상품에 하자가 있는 경우, [오류설정] 하세요
                    </div>

                    <app-input-ex
                        class="uk-margin-bottom"
                        type="text"
                        input-size="large"

                        v-model="expirationDate"
                        label="유통기한"

                        required-layout="label-left"

                        placeholder="날짜입력"
                    >
                        <div slot="label" class="uk-flex uk-flex-bottom">
                            <div class="font-bold">유통기한</div>
                            <div class="ml-1rem bg-yellow-100 p-2 border border-gray">건강식품/식품, 동물영양제인 경우만 입력해 주세요</div>
                        </div>
                    </app-input-ex>

                    <div class="uk-text-right">
                        <!--- 버튼 -->
                        <button
                            type="button"
                            class="uk-button uk-button-default uk-button-large2 uk-modal-close"
                        >
                            <span uk-icon="icon: close"></span> 취소
                        </button>
                        <button
                            type="button"
                            class="uk-button uk-button-danger uk-button-large2"
                            v-on:click="submit()"
                        >
                            <span uk-icon="icon: check"></span>
                            보류
                        </button>
                    </div>
                </div>

                <!-- 보관장소 -->
                <div v-if="currStep === 2" style="height: 220px">
                    <!-- 토글버튼 -->
                    <toggle-button
                        v-model="isRandomStorage"
                        :labels="{checked: '보관장소 랜덤작성', unchecked: '보관장소 직접작성'}"
                        :width="200"
                        :height="36"
                        :font-size="18"
                    />

                    <!-- 직접작성 -->
                    <div v-show="! isRandomStorage">
                        <div class="uk-margin-small-bottom uk-text-muted">
                            보관장소를 수동으로 직접 입력합니다
                        </div>

                        <app-input-ex
                            class="uk-margin-bottom"
                            type="text"
                            input-size="large"

                            name="memo"
                            v-model="storage"
                            label="보관장소"

                            required-layout="label-left"

                            placeholder="보관장소를 입력하세요"
                        > </app-input-ex>

                        <div class="uk-text-right">
                            <button
                                type="button"
                                class="uk-button uk-button-primary uk-button-large2"
                                v-on:click="doneStep2"
                            >
                                <span uk-icon="icon: check"></span>
                                보관장소 입력
                            </button>
                        </div>
                    </div>

                    <!-- 랜덤작성 -->
                    <div v-show="isRandomStorage">
                        <div class="uk-margin-small-bottom uk-text-muted">
                            fixed 부분을 제외한 나머지 숫자5자리를 랜덤하게 생성
                            (중복되지 않는 고유한 보관장소 발행)
                        </div>

                        <div class="uk-flex uk-flex-left uk-margin-small-bottom">

                            <div class="uk-width-small uk-margin-right">
                                <span class="uk-text-large">fixed</span>
                                <div>
                                    <app-input-text
                                        v-model="randomStorageFixed"
                                        placeholder="e.g. OS1"
                                        input-size="large"
                                        text-style="font-size: 2rem; text-align: center;"
                                    ></app-input-text>
                                </div>
                            </div>

                            <div class="">
                                <span class="uk-text-large">random sample</span>
                                <div class="random-sample">
                                    - 00000
                                </div>
                            </div>


                        </div>

                        <div class="uk-text-right">
                            <button
                                type="button"
                                class="uk-button uk-button-primary uk-button-large2"
                                v-on:click="createRandomStorage"
                            >
                                <span uk-icon="icon: check"></span>
                                랜덤 보관장소 생성
                            </button>
                        </div>
                    </div>

                </div>

                <!-- 라벨출력 -->
                <div v-if="currStep === 3">
                    <div class="uk-text-large uk-text-center uk-margin-bottom">
                        보관라벨 출력 후 해당 장소에 상품을 갖다놓으세요
                    </div>

                    <div class="uk-text-large4 uk-text-center uk-margin-bottom uk-text-primary">
                        {{ storage }}
                    </div>

                    <div class="uk-text-center uk-margin-bottom">
                        <button
                            type="button"
                            class="uk-button uk-button-primary uk-button-large2"
                            onclick="$.app.print.store_label(arguments);"
                            :data-prod-id="prodId"
                            title="현재 상품의 보관라벨을 출력합니다"
                        >
                            <i class="material-icons" style="font-size: 48px; vertical-align: middle">print</i>
                            <span class="text">PRINT STORE-LABEL (보관라벨)</span>
                        </button>
                    </div>

                    <hr />

                    <div class="uk-text-right">
                        <button
                            type="button"
                            class="uk-button uk-button-default uk-button-large2 uk-margin-right"
                            v-on:click="currStep = 2"
                        >
                            <i class="material-icons">keyboard_arrow_left</i>
                            뒤로 (보관장소 수정)
                        </button>
                        <button
                            type="button"
                            class="uk-button uk-button-primary uk-button-large2 uk-modal-close"
                        >
                            <i class="material-icons">check</i>
                            완료
                        </button>
                    </div>
                </div>

            </div>



        </div>
    </div>
</template>

<script>
    export default {
        components: {
            'request': require('./tracking-check/request.vue').default,
        },
        props: {
            // csrf-token
            csrfToken: String,

            // 상품ID
            prodId: Number,

            /**
             * 보류요청서
             */
            holdRequest: {
                type: Object,
                default: null
            },
        },
        data: function () {
            return {
                /**
                 * (bool) 보관장소 랜덤작성 여부
                 */
                isRandomStorage: false,

                /**
                 * 랜덤 보관장소 fixed
                 */
                randomStorageFixed: null,

                /**
                 * 유통기한
                 */
                expirationDate: null,

                /**
                 * 보관장소
                 */
                storage: null,

                /**
                 * (int) 진행단계
                 *       1~3
                 **/
                currStep: 1,

                // (bool) 모달창 종료이벤트 등록된적있는지 플래그값, 창 여러번 켜고 닫을때, 이벤트 한번만 등록되기 위함
                hasModalCloseEvent: false,
            };
        },
        computed: {
            // 스텝1 클래스계산
            step1Class: function () {
                let step = 1;

                return {
                    complete: this.currStep > step,
                    active: this.currStep === step,
                };
            },
            // 스텝2 클래스계산
            step2Class: function () {
                let step = 2;

                return {
                    complete: this.currStep > step,
                    active: this.currStep === step,
                };
            },
            // 스텝3 클래스계산
            step3Class: function () {
                let step = 3;

                return {
                    complete: this.currStep > step,
                    active: this.currStep === step,
                };
            },
        },
        methods: {

            /**
             * 폼
             */
            form() {

                // 초기화
                this.expirationDate = null;

                // 폼 띄우기
                UIkit.modal(this.$el).show();


                // 모달창 종료이벤트
                if (! this.hasModalCloseEvent) {
                    UIkit.util.on(this.$el, 'beforehide', () => {
                        //console.log('before');
                        this.close();

                    });

                    this.hasModalCloseEvent = true;
                }
            },




            /**
             * submit
             */
            submit() {
                // promise 생성
                let p = new Promise((resolve, reject) => {
                    //reject('failed !');

                    // ajax 옵션
                    let opts = {
                        type: 'post',
                        url: '/prods/' + this.prodId + '/holds',
                        data: {
                            '_token': this.csrfToken,
                            'hold_reason': this.holdRequest.hold_reason,
                            'expiration_date': this.expirationDate,
                        },
                        success: (response, textStatus, jqXHR) => {
                            // promise 성공
                            resolve(response);
                        },
                        error: function(jqXHR, textStatus, errorThrown) {
                            reject();
                        },
                    };

                    // ajax 실행
                    $.app.ajax.module.default(opts);
                });


                // promise 처리
                p.then((response) => {
                    this.storage = response.storage;

                    // 보관장소가 발급되었으면, 입력단계 건너뜀
                    if (this.storage) {
                        this.currStep = 3;
                    } else {
                        this.currStep = 2;
                    }

                }).catch(() => {
                    // 오류인경우, 모달 종료
                    //UIkit.modal(this.$el).hide();
                });
            },

            /**
             * step2 완료처리
             */
            doneStep2() {
                // promise 생성
                let load = new Promise((resolve, reject) => {
                    // ajax 옵션
                    let opts = {
                        type: 'patch',
                        url: '/prods/' + this.prodId + '/storage',
                        data: {
                            '_token': this.csrfToken,
                            'storage': this.storage,
                        },
                        success: (response, textStatus, jqXHR) => {
                            // promise 성공
                            resolve(response);
                        },
                        error: function(jqXHR, textStatus, errorThrown) {
                            reject();
                        },
                    };

                    // ajax 실행
                    $.app.ajax.module.default(opts);
                });


                // promise 처리
                load.then((response) => {
                    this.currStep = 3;
                }).catch(() => {
                    // 오류인경우, 모달 종료
                    UIkit.modal(this.$el).hide();
                });
            },

            /**
             * 랜덤보관장소 생성처리
             */
            createRandomStorage() {
                // promise 생성
                let load = new Promise((resolve, reject) => {
                    // ajax 옵션
                    let opts = {
                        type: 'patch',
                        url: '/prods/' + this.prodId + '/random-storage',
                        data: {
                            '_token': this.csrfToken,
                            'fixed':  this.randomStorageFixed,
                        },
                        success: (response, textStatus, jqXHR) => {
                            // promise 성공
                            resolve(response);
                        },
                        error: function(jqXHR, textStatus, errorThrown) {
                            reject();
                        },
                    };

                    // ajax 실행
                    $.app.ajax.module.default(opts);
                });


                // promise 처리
                load.then((response) => {
                    this.currStep = 3;
                    this.storage = response.storage;
                }).catch(() => {
                    // 오류인경우, 모달 종료
                    UIkit.modal(this.$el).hide();
                });
            },



            /**
             * 작업완료 (창 닫기했을때 실행되는 액션)
             */
            close() {
                // 첫번째 단계가 지났으면, 보류설정이 완료되었으므로, 완료이벤트 발생
                if (this.currStep > 1) {
                    // 완료 이벤트 발생
                    this.$emit('done', null);
                }
            },
        },
    }
</script>

<style lang="scss" scoped>
    /*
    stepper css
    https://codepen.io/shanejdonnelly/pen/wJqgQR?page=3
    */
    .stepper{
        clear: left;
        float: left;
        font-size: 1.5rem;
        margin: 10px;
    }

    .step{
        float: left;
    //    font-size: 15px;
        margin: 0 12px;
    }

    .divider{ border-bottom: 1px solid #cfcfcf; float: left; height: 12px; margin: 0 12px; width: 45px; }

    .circle{
        background: #cfcfcf;
        border-radius: 50%;
        color: #ffffff;
        float: left;
        height: 30px;
        line-height: 30px;
        text-align: center;
        width: 30px;
    }

    .label{ color: #cfcfcf; float: left; line-height: 24px; margin-left: 8px; }

    .active{
        .circle{ background: #0f7ae5; }
        .label{ color: #0f7ae5; font-weight: 400; }
    }

    .complete{
        .circle{
            background: #666;
        }
        .label{
            color: #666;
            text-decoration-line: line-through;
        }
    }

    // 랜덤보관장소 샘플부분
    .random-sample {
        font-size: 2.5rem;
        color: #999;
        text-align: left;
    }
</style>
